import { ROUTE } from "../../../routes";
import { getApplicationId, getUserContext } from "../../../configs/utils";
import { getAppHeader } from "../../../configs/config";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
export const openSuccessModal = async ({ setDatastore }) => {
    await setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        showSuccessModal: true,
        showWaitingForResponse: false,
        showFailureModal: false,
        counter: Math.random()
    });
};
export const openFailureModal = async ({ setDatastore }) => {
    setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        showSuccessModal: false,
        showWaitingForResponse: false,
        showFailureModal: true,
        counter: Math.random()
    });
};
export const openLoaderModal = async ({ setDatastore }) => {
    setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        showWaitingForResponse: true,
        counter: Math.random()
    });
};
export const loadAgreementLinkToWebView = async ({ setDatastore, network, successCb }) => {
    await setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        loading: true,
        counter: Math.random()
    });
    const agreementLinkStepResponseObject = await getAgreementLink({ network });
    if (agreementLinkStepResponseObject?.status?.toLowerCase() === 'accepted') {
        await openSuccessModal({ setDatastore });
        successCb &&
            successCb();
    }
    const agreementLink = agreementLinkStepResponseObject?.link;
    await setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        loading: false,
        url: agreementLink,
        counter: Math.random()
    });
};
export const resetModal = async ({ setDatastore }) => {
    setDatastore(ROUTE.DSP_KFS, 'dspKfsPage', {
        showSuccessModal: false,
        showFailureModal: false,
        showWaitingForResponse: false,
        counter: Math.random()
    });
};
export const getMandateDeepCheckStatus = async ({ network }) => {
    const application_id = await getApplicationId();
    const mandateLinkStatus = await network.get(`${api.mandateStatusV3}${application_id}`, {
        headers: await getAppHeader()
    });
    if (mandateLinkStatus?.data?.status === 'SUCCESS') {
        //Update user's linkedApplications context linkedApplication
        let user = await getUserContext(network);
        user.linkedApplications[0] = mandateLinkStatus?.data?.updatedApplicationObj;
        await SharedPropsService.setUser(user);
    }
    return mandateLinkStatus?.data?.stepResponseObject?.status;
};
export const getAgreementLink = async ({ network }) => {
    const application_id = await getApplicationId();
    const mandateLink = await network.get(`${api.mandateLinkV3}${application_id}`, {
        headers: await getAppHeader()
    });
    if (mandateLink?.data?.status === 'SUCCESS' &&
        mandateLink?.data?.stepResponseObject?.status?.toLowerCase() === 'accepted') {
        //Update user's linkedApplications context linkedApplication
        let user = await getUserContext(network);
        user.linkedApplications[0] = mandateLink?.data?.updatedApplicationObj;
        await SharedPropsService.setUser(user);
    }
    return mandateLink?.data?.stepResponseObject;
};
